import { PLATFORM_NAME, WORDMARK } from "../brand";
import "./BrandWordmark.css";

/**
 * The platform wordmark: OMJ VISI👁️N.
 *
 * The eye is decoration standing where a letter should be, so the whole
 * wordmark carries one `aria-label` of the real name and every visible part
 * of it is hidden from assistive technology. Read aloud it is "OMJ VISION";
 * without this it would be "OMJ VISI eye N", and an emoji's own description
 * is not something a brand should be at the mercy of.
 *
 * The glyph is nudged and scaled in CSS rather than trusted to sit on the
 * baseline at the same weight as the letters around it — an emoji is a
 * different font with different metrics, and at the sizes a logo is set it
 * shows.
 *
 * @param {{size?: "sm"|"md"|"lg", as?: React.ElementType, className?: string}} props
 */
function BrandWordmark({ size = "md", as: Tag = "span", className = "" }) {
  return (
    <Tag
      className={`brandmark brandmark--${size}${className ? ` ${className}` : ""}`}
      aria-label={PLATFORM_NAME}
      role="img"
    >
      <span aria-hidden="true">{WORDMARK.lead}</span>
      <span className="brandmark__eye" aria-hidden="true">
        {WORDMARK.eye}
      </span>
      <span aria-hidden="true">{WORDMARK.trail}</span>
    </Tag>
  );
}

export default BrandWordmark;
